export default __webpack_public_path__ + "static/media/tartous.eb277cdb.jpg";